import React from 'react';

const Settings = () => {
    return (
        <div>
            <h4> Welcome Back to the settings</h4>
        </div>
    );
};

export default Settings;